import styled, { css } from 'styled-components';
import { Flex } from '@catalogo/theme-layout';
import { Text } from '@catalogo/theme-text';

export const FlexboxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0 16px;
`;

export const WrapperOption = styled(FlexboxWrapper)`
  color: ${({ theme }) => theme.grey.dark};
  margin-top: 16px;
  flex-wrap: wrap;
  ${({ $showLastCol }) => $showLastCol && 'flex-wrap: wrap;'}
`;

export const ColUI = styled(Flex)`
  align-items: flex-start;
  ${({ $hasListPrice }) =>
    $hasListPrice &&
    css`
      flex-direction: column;
      align-items: flex-end;
    `};

  ${({ $isLoading }) =>
    $isLoading &&
    css`
      @keyframes gradient {
        0% {
          background-position: 100% 100%;
        }
        100% {
          background-position: 0% 0%;
        }
      }

      color: transparent;
      background: linear-gradient(135deg, #d7d7d7, #fafafa, #d7d7d7);
      background-size: 250%;
      animation: gradient 2s ease infinite;
      border-radius: 4px;

      svg {
        fill: transparent;
      }
    `};
`;

export const ColUIFull = styled(ColUI)`
  width: 100%;
`;

export const ColUIChronometer = styled(ColUIFull)`
  margin-left: 25px;
  ${({ $isLoading }) => $isLoading && 'opacity: 0;'};
`;

export const TextFreight = styled(Text)`
  max-width: 185px;
  margin-top: 2px;

  @media (min-width: 768px) {
    max-width: 175px;
  }
`;

export const TextUI = styled(Text)`
  font-weight: bold;
  display: flex;
  align-items: center;
  padding-top: 2px;
  ${({ freeShipping, $isLoading }) => freeShipping && !$isLoading && `color: #008000;`};
  ${({ $isLoading }) => $isLoading && 'padding-bottom: 2px'};

  s {
    inline-size: max-content;
  }
`;
